<script setup lang="ts">
import Trip from '@itinerary/trip/Trip';

const contentStore = useContentStore();
const {
    corporationIds,
    corporationTitle,
    landingDistances,
    landingPageContent,
} = classToRefs(contentStore);
const haveData = computed(
    () => !!corporationIds.value.length || !!landingDistances.value.length
);
</script>

<template>
    <div v-if="haveData" class="destination-info-container">
        <div class="content-container">
            <NuxtImg
                format="webp"
                :src="`/img/city-landings/${landingPageContent?.parent}.png`"
                :alt="landingPageContent?.parent"
                class="image-section"
            />
            <div class="data-section">
                <template v-if="corporationIds.length">
                    <h2>شرکت‌های {{ corporationTitle }}</h2>
                    <div class="logos-box">
                        <template v-if="landingPageContent?.parentReserveType">
                            <NuxtImg
                                v-for="corporationId in corporationIds"
                                :key="corporationId"
                                :src="
                                    Trip.getLogo(
                                        landingPageContent.parentReserveType,
                                        corporationId
                                    )
                                "
                                class="logo"
                                alt="logo"
                            />
                        </template>
                    </div>
                </template>
                <template v-if="landingDistances.length">
                    <h2>فاصله تا شهرهای دیگر</h2>
                    <div
                        v-for="item in landingDistances"
                        :key="item.id"
                        class="distance-container"
                    >
                        <div>
                            {{ landingPageContent?.cityName }} تا
                            {{ item.city }}
                        </div>
                        &nbsp;
                        <div>
                            {{ item.distance }}
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.destination-info-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background: usePalette();
    width: 100%;

    .content-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        max-width: $app-container-max-width;
        gap: 40px;
        padding: 12px 8px;
        @include mobile-only {
            flex-direction: column;
            align-items: stretch;
            .image-section {
                display: none;
            }
            .data-section {
                align-items: stretch;
            }
        }
        .image-section {
            flex: 2;
            object-fit: contain;
        }
        .data-section {
            flex: 3;
            display: flex;
            flex-direction: column;
            gap: 8px;
            h2 {
                margin: 0;
            }
        }
    }
}

.logos-box {
    display: flex;
    .logo {
        height: 30px;
        padding-left: 16px;
    }
}

.distance-container {
    display: flex;
    max-width: 400px;
    background: rgba($color: white, $alpha: 0.2);
    border-radius: 5px;
    padding: 5px 10px;
    // text
    @include tg-m($color: white);
}
</style>
